<template>
  <div>
    <ul
      class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled"
      id="accordionSidebar"
      style="min-height: 89vh"
    >
      <div class="text-center d-none d-md-inline mt-3">
        <button
          class="rounded-circle border-0"
          id="sidebarToggle"
        />
      </div>

      <!-- Divider -->
      <hr class="sidebar-divider my-0">

      <!-- Nav Item - Dashboard -->
      <li class="nav-item active">
        <router-link
          to="/staffDashboard"
          tag="a"
          class="nav-link collapsed"
          href="#"
        >
          <i class="fas fa-fw fa-tachometer-alt" />
          <span>Dashboard</span>
        </router-link>
      </li>

      <hr class="sidebar-divider my-sm-0">

      <li class="nav-item">
        <router-link
          to="/crews"
          tag="a"
          class="nav-link collapsed"
          href="#"
        >
          <i class="fas fa-fw fa-users" />
          <span>Crew List</span>
        </router-link>
      </li>


      <hr class="sidebar-divider">

      <!-- Training Schedule -->
      <li class="nav-item">
        <router-link
          to="/trainingSchedule"
          tag="a"
          class="nav-link collapsed"
        >
          <i class="fas fa-fw fa-calendar-alt" />
          <span>Training Schedule</span>
        </router-link>
      </li>

      <!-- Divider -->
      <hr class="sidebar-divider">

      <!-- Reports -->

      <li
        class="nav-item dropdown"
        v-if="isTrainingDept"
      >
        <a
          class="nav-link dropdown-toggle"
          type="button"
          id="reportsDropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-fw fa-cogs" />
          <span>Reports</span>
        </a>

        <div
          id="reports"
          class="dropdown-menu collapse py-0"
          aria-labelledby="setupDropdown"
          data-parent="#accordionSidebar"
        >
          <div class="collapse-inner rounded m-0">
            <router-link
              :to="{name: 'allowance'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Crew Allowance Report
            </router-link>
            <router-link
              :to="{name: 'crewMonitoring'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Crew Monitoring Report
            </router-link>
            <router-link
              :to="{name: 'trainingMonitoringCalendar'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Training Monitoring
            </router-link>
            <router-link
              :to="{name: 'antipiracy'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Anti Piracy Report
            </router-link>
            <router-link
              :to="{name: 'pdos'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              PDOS Report
            </router-link>
            <router-link
              :to="{name: 'retentionMonitoring'}"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Retention Monitoring
            </router-link>
            <router-link
              :to="{name: 'trainingEndorsementReport'}"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              Training Endorsement
            </router-link>
          </div>
        </div>
      </li>

      <!--            <li class="nav-item" v-if="isManager">-->
      <!--                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#reports" aria-expanded="true" aria-controls="reports">-->
      <!--                    <i class="fas fa-fw fa-file-alt"></i>-->
      <!--                    <span>Reports</span>-->
      <!--                </a>-->

      <!--                <div id="reports" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">-->
      <!--                    <div class="bg-white py-2 collapse-inner rounded">-->
      <!--                        <router-link :to="{name: 'allowance'}" class="collapse-item" style="text-align: left;font-size: 0.8em;">Crew Allowance Report</router-link>-->
      <!--                        <router-link :to="{name: 'crewMonitoring'}" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">Crew Monitoring Report</router-link>-->
      <!--                        <router-link to="/trainingMonitoring" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">Training Monitoring</router-link>-->
      <!--                        <router-link :to="{name: 'antipiracy'}" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">Anti Piracy Report</router-link>-->
      <!--                        <router-link :to="{name: 'pdos'}" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">PDOS Report</router-link>-->
      <!--                        <router-link :to="{name: 'retentionMonitoring'}" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">Retention Monitoring</router-link>-->
      <!--                        <router-link :to="{name: 'trainingEndorsementReport'}" class="collapse-item" tag="a" style="text-align: left; font-size: 0.8em;">Training Endorsement</router-link>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </li>-->

      <!-- Divider -->
      <hr
        class="sidebar-divider"
        v-if="isManager"
      >

      <li
        class="nav-item dropdown"
        v-if="isScheduler"
      >
        <a
          class="nav-link dropdown-toggle"
          type="button"
          id="setupDropdown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-fw fa-cogs" />
          <span>Setup</span>
        </a>

        <div
          id="setupItems"
          class="dropdown-menu collapse py-0"
          aria-labelledby="setupDropdown"
          data-parent="#accordionSidebar"
        >
          <div class="collapse-inner rounded m-0">
            <router-link
              v-if="isSystemAdmin"
              to="/trainingProvider"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Training Providers
            </router-link>
            <router-link
              to="/trainingCourse"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Training Courses
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/trainingCenter"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Training Centers
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/instructor"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Instructors
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/rankTypes"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Rank Types
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/ranks"
              tag="a"
              class="collapse-item dropdown-item m-0"
              style="text-align: left;"
            >
              Ranks
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/vesselTypes"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              Vessel Types
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/vessels"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              Vessels
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/userTypes"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              User Types
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/users"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              User
            </router-link>
            <router-link
              v-if="isSystemAdmin"
              to="/principal"
              class="collapse-item dropdown-item m-0"
              tag="a"
              style="text-align: left;"
            >
              Principals
            </router-link>
          </div>
        </div>
      </li>

      <!-- Divider -->
      <hr
        class="sidebar-divider"
        v-if="isSystemAdmin"
      >

      <!-- Setup -->
      <!--            <li class="nav-item">-->
      <!--                <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#logs" aria-expanded="true" aria-controls="logs">-->
      <!--                    <i class="fas fa-fw fa-user-cog"></i>-->
      <!--                    <span>Logs</span>-->
      <!--                </a>-->
      <!--            </li>-->

      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block">
    </ul>
  </div>
</template>

<script>
    import { gateMixins } from '../../mixins/gateMixins'
    export default {
        mixins: [ gateMixins ],
        name: 'SideNavigation',



    };
</script>

<style scoped>

</style>
